import { FC } from 'react';
import useEditEventButtonsBar from './EditEventButtonsBar.hook';
import { EditEventButtonActionStates } from './EditEventButtonsBar.types';
import ButtonsBar, { StepButtonsConfig } from 'components/ButtonsBar/ButtonsBar';

export type EditEventButtonsBarProps = {
  buttonsConfig: StepButtonsConfig | null;
  actionStates: EditEventButtonActionStates;
};

const EditEventButtonsBar: FC<EditEventButtonsBarProps> = ({ buttonsConfig, actionStates }) => {
  const finalConfig = useEditEventButtonsBar({ config: buttonsConfig, actionStates });

  if (!finalConfig) {
    return null;
  }

  return <ButtonsBar { ...finalConfig } />;
};

export default EditEventButtonsBar;
